var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "is-responsive": _vm.isResponsivePages }, attrs: { id: "app" } },
    [
      _c("Indicator"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("vue-progress-bar"),
      _vm._v(" "),
      _vm.showsScrollTop
        ? _c(
            "section",
            {
              directives: [
                {
                  name: "scroll",
                  rawName: "v-scroll",
                  value: _vm.handleScroll,
                  expression: "handleScroll",
                },
              ],
            },
            [
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.position > 700
                  ? _c("div", { attrs: { id: "page_top" } }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "scroll-to",
                              rawName: "v-scroll-to",
                              value: "body",
                              expression: "'body'",
                            },
                          ],
                        },
                        [
                          _c("span", {
                            staticClass:
                              "boss-icon boss-icon-angle-up-solid pega-icon-page-top",
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }